import React from 'react';
import { cn } from '../../lib/utils';
import { SidebarHeader } from './SidebarHeader';
import { Navigation } from './Navigation';
import { History } from './History';
import { NewChatButton } from './NewChatButton';
import { useSidebar } from 'contexts/SidebarContext';

export const Sidebar: React.FC = () => {
  const { isCollapsed, toggleCollapse } = useSidebar();

  return (
    <div
      className={cn(
        'transition-[width] duration-100 ease-in-out border-r border-border',
        'bg-[rgba(217,217,217,0.20)]', // Figma: rgba(217, 217, 217, 0.20)
        isCollapsed ? 'w-20' : 'w-[280px]', // Fixed widths to prevent layout shift
      )}
    >
      <div className="flex flex-col h-full">
        {/* Header with Logo and Collapse Button */}
        <SidebarHeader isCollapsed={isCollapsed} onToggleCollapse={toggleCollapse} />

        {!isCollapsed && (
          <>
            {/* Chat Assistant Header */}
            <div className="px-6 pt-4 pb-0">
              <h2 className="text-black font-bold font-ld">Chat Assistant</h2>

              {/* New Chat Button */}
              <NewChatButton isCollapsed={isCollapsed} />
            </div>

            {/* Navigation */}
            <Navigation isCollapsed={isCollapsed} />

            {/* History Section */}
            <History isCollapsed={isCollapsed} />
          </>
        )}
      </div>
    </div>
  );
};
